import Center from '@components/common/alignment/Center';
import ContentBox from '@components/common/ContentBox';
import React from 'react';

const ResetSent: React.FC = () => {
  return (
    <Center>
      <ContentBox>
        <text className='font-raleway text-deepspace text-center text-xl'>
          Password reset link sent! Check your email. <br></br>
          Keep in mind that <strong> the email may have arrived in your spam inbox.</strong>
        </text>
      </ContentBox>
    </Center>
  );
};

export default ResetSent;
